import React, { useEffect, useState } from 'react'
import { oktmo2name } from './Utils'

export default function WeatherReg(props) {
	
	const { ENV, DS, region } = props
	
	const [weather, setWeather] = useState(undefined)
	const [danger, setDanger] = useState(false)
	const [warning, setWarning] = useState(false)
	
	const weather_warnings_2 = {
		'1': 'Возможно нарушение электроснабжения',
		'2': 'Возможно нарушение электроснабжения, <div class="text-tiny">а также подтопление электросетевого оборудования на ТС и ПС, падение и повреждение опор</div>',
		'3': 'Возможно нарушение электроснабжения и/или газоснабжения, <div class="text-tiny">а также подтопление электросетевого оборудования на ТС и ПС, падение и повреждение опор</div>',
	}

	useEffect(() => {
		const _w = DS.data.weather.find(([k, v]) => k == region)
		setWeather(_w ? _w[1] : undefined)
	}, [DS.data.weather, region])
	
	useEffect(() => {
		setWarning(DS.data.showWeatherWarnings && weather?.w === 'break')
		setDanger(DS.data.showWeatherDangers && weather?.p >= DS.data.weatherThresh)
	}, [weather, DS.data.showWeatherWarnings, DS.data.showWeatherDangers])
	
	return <div className="col weather-reg p-3">
		{ !danger && !warning && <div className="font-bold text-lg text-300">{oktmo2name[region]}</div>}
		{ danger || warning
			? <>
				{warning && weather.wd && <div className="">
					<p className="title">{'Предупреждения в связи с плохими погодными условиями'}</p>
					<div className="text-uppercase text-red mt-3 text-1em5" dangerouslySetInnerHTML={{ __html: weather_warnings_2[weather.wd.msg] }}></div>
					<div className="text-uppercase text-red mt-2 ml-3">{weather.wd.title.map((e, i) => <p key={i} className="m-0">{e}</p>)}</div>
					{ weather.wd.limit && <div className="text-uppercase ml-3 text-300">{weather.wd.limit}</div> }
					{ false && weather.wd.n === 1
						? weather.wd.desc.map(e => e.d).reduce((a, e) => [...a, ...e], []).map((e, i) => <p key={i} className="m-0 ml-3">{e}</p>)
						: weather.wd.desc.map((e, i) => <div key={i}>
								<div className="text-1em5 text-300 mt-2">{e.s}</div>
								{e.d.map((e, i) => <p key={i} className="m-0 ml-3">{e}</p>)}
							</div>)
					}
				</div>}
				{danger && warning && <div className="border-top mb-3"></div>}
				{danger && weather.inf && <div className="">
					<p className="title">{'Прогноз по погодной опасности'}</p>
					{weather.inf.map((e, i) => <div key={i} className="">
						<div className="text-1em5 text-300 mt-2">{e.s}</div>
						{e.d.map((e, i) => <div key={i} className="flex">
							<div className="col col-1 mt-1"><img src={`${ENV.imgUrl}weather/${e.i}.gif`}/></div>
							<div className="col">
								<div className="font-bold text-lg">{e.t}</div>
								<div>{e.d}</div>
								<div className="text-300">{e.w}</div>
							</div>
						</div>)}
					</div>)}
				</div>}
			</>
			: <div className="mt-3"><p className="title">{'Нет информации за выбранный период'}</p></div>
		}
	</div>
	
}

